import { Injectable } from '@angular/core';
import { RouteDataStoreService } from 'src/app/modules/aa-core/services/data-store/data-store.service';
import { MapsHotelsModel, TRAVEL_TYPE } from '../../models/maps-hotels-model';
import { AAGoogleMarkerService } from 'src/app/modules/aa-core/services/google/google-marker/aa-google-marker.service';
import { GoogleMapStoreService } from 'src/app/modules/google-map/services/google-map-store/google-map-store.service';
import { LocationService } from 'src/app/modules/aa-core/services/location-service/location.service';
import { RoutePlannerService } from 'src/app/modules/route-planner/services/route-planner/route-planner.service';
import { AALocationModel } from 'src/app/modules/route-planner/models/route-model';
import { TrafficAlertType, GoogleMapType } from 'src/app/modules/google-map/enums/google-map-enum';
import { TravelMarkerService } from 'src/app/modules/google-map/services/marker-cluster/travel-marker.service';
import { CarParkMarkerService } from 'src/app/modules/google-map/services/marker-cluster/car-park-marker.service';
import { AARouterURL } from 'src/app/modules/app-routing/enums/routing.enum';
import { AAConstant } from 'src/app/core/models/constants';
import { AppRouterDataService } from 'src/app/modules/app-routing/services/app-router-data/app-router-data.service';
import { TrafficNewsAndMapService } from 'src/app/modules/aa-core/services/traffic-news-and-map/traffic-news-and-map.service';

@Injectable({
  providedIn: 'root'
})
export class MapsHotelsService extends TrafficNewsAndMapService {

  public mapsHotelsModel: MapsHotelsModel;
  private trafficAlertTimer: any;
  constructor(private dataStore: RouteDataStoreService,
    public googleMapStore: GoogleMapStoreService,
    public travelMarkerService: TravelMarkerService,
    public carParkMarkerService: CarParkMarkerService,
    public locationService: LocationService,
    private appRouterDataService: AppRouterDataService,
    public routePlannerService: RoutePlannerService,
    public aaMarkerService: AAGoogleMarkerService) {
    super(aaMarkerService, googleMapStore, locationService, routePlannerService);

    this.mapsHotelsModel = this.dataStore.mapsHotelsModel;
    this.locationModel = this.mapsHotelsModel.locationModel;
  }

  public initMap(params: any) {
    let locationName: string = AAConstant.CURRENT_LOCATION;

    if (params[AARouterURL._LOCATION]) {
      locationName = params[AARouterURL._LOCATION];
    } else if (params[AARouterURL._LAT] && params[AARouterURL._LON]) {
      locationName = `${params[AARouterURL._LAT]}, ${params[AARouterURL._LON]}`;
    } else if (params[AARouterURL._LAT] && params[AARouterURL._LNG]) {
      locationName = `${params[AARouterURL._LAT]}, ${params[AARouterURL._LNG]}`;
    }

    if (params[AARouterURL._ZOOM]) {
      this.defaultZoomLevel = parseInt(params[AARouterURL._ZOOM]);
    }

    this.locationModel.setName(locationName, this.locationModel.Name !== locationName);
    this.loadMapData(GoogleMapType.MAPS);
  }

  public destroy(mapType: GoogleMapType): void {
    super.destroy(mapType);
  }

  public updateRouterURL() {
    if (this.locationModel.validName()) {
      this.appRouterDataService.updateURL(AARouterURL.MAP_HOTELS);
    }
  }

  public onLocationReady(locationList: Array<AALocationModel>): void {
    super.onLocationReady(locationList);
    this.loadDefaultMapOptions();
  }

  public locationNotFound(): void {
    this.loadDefaultMapOptions(10);
  }

  public mapUpdateEventListener = (mapType: GoogleMapType) => {
    this.loadDefaultMapOptions(10);
  }

  public loadDefaultMapOptions(delay: number = 0): void {
    clearTimeout(this.trafficAlertTimer);
    this.trafficAlertTimer = setTimeout(() => {
      this.updateMapOptions();
    }, delay);
  }

  public updateMapOptions(): void {
    const travelTypes: Array<TRAVEL_TYPE> = [];
    const carParkSelected = false;

    this.mapsHotelsModel.mapsOptionsData.forEach( option => {
      if (option.value) {
        switch (option.type) {
          case TrafficAlertType.HOTELS_AND_B_B:
            travelTypes.push(TRAVEL_TYPE.BUD);
            travelTypes.push(TRAVEL_TYPE.HOT);
            travelTypes.push(TRAVEL_TYPE.GAC);
            break;
          case TrafficAlertType.RESTAURANTS:
            travelTypes.push(TRAVEL_TYPE.RES);
            break;
          // case TrafficAlertType.CAR_PARKS:
          //   carParkSelected = true;
          //   break;
        }
      }
    });

    if (travelTypes.length) {
      this.travelMarkerService.loadTravelData(this.googleMap, travelTypes);
    } else {
      this.travelMarkerService.clear();
    }

    if (carParkSelected) {
     // this.carParkMarkerService.loadCarParkData(this.googleMap);
    } else {
      this.carParkMarkerService.clearAll();
    }
  }

}
